import { ChangeHandler, RefCallBack, UseFormRegisterReturn } from "react-hook-form";

export type AsInputRefReturn = {
    onChange: ChangeHandler;
    onBlur: ChangeHandler;
    inputRef: RefCallBack;
    name: string;
};

export function asInputRef(register: UseFormRegisterReturn): AsInputRefReturn {
    return {
        inputRef: register.ref,
        name: register.name,
        onChange: register.onChange,
        onBlur: register.onBlur
    };
}


